// extracted by mini-css-extract-plugin
module.exports = {"app":"styles_app__2-7Lo","infoBoxContainer":"styles_infoBoxContainer__3jt6z"};